import palette from './palette';

export default {
  h1: {
    color: palette.text.primary,
    fontWeight: 800,
    fontSize: '64px',
    letterSpacing: '-0.24px',
    lineHeight: '80px'
  },
  h2: {
    color: palette.text.primary,
    fontWeight: 800,
    fontSize: '48px',
    letterSpacing: '-0.24px',
    lineHeight: '64px'
  },
  h3: {
    color: palette.text.primary,
    fontWeight: 700,
    fontSize: '32px',
    letterSpacing: '-0.06px',
    lineHeight: '48px'
  },
  h4: {
    color: palette.text.primary,
    fontWeight: 700,
    fontSize: '24px',
    letterSpacing: '-0.06px',
    lineHeight: '36px'
  },
  h5: {
    color: palette.text.primary,
    fontWeight: 700,
    fontSize: '20px',
    letterSpacing: '-0.05px',
    lineHeight: '30px'
  },
  h6: {
    color: palette.text.primary,
    fontWeight: 600,
    fontSize: '18px',
    letterSpacing: '-0.05px',
    lineHeight: '28px'
  },
  subtitle1: {
    color: palette.text.primary,
    fontSize: '16px',
    fontWeight: 600,
    letterSpacing: '-0.05px',
    lineHeight: '24px',
    fontFamily: 'Public Sans, sans-serif'
  },
  subtitle2: {
    color: palette.text.primary,
    fontWeight: 600,
    fontSize: '14px',
    letterSpacing: '-0.05px',
    lineHeight: '22px',
    fontFamily: 'Public Sans, sans-serif'
  },
  body1: {
    color: palette.text.primary,
    fontSize: '16px',
    fontWeight: 400,
    letterSpacing: '-0.05px',
    lineHeight: '24px',
    fontFamily: 'Public Sans, sans-serif'
  },
  body2: {
    color: palette.text.primary,
    fontSize: '14px',
    fontWeight: 400,
    letterSpacing: '-0.04px',
    lineHeight: '22px',
    fontFamily: 'Public Sans, sans-serif'
  },
  button: {
    color: palette.text.primary,
    fontFamily: 'Public Sans, sans-serif',
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '26px',
  },
  caption: {
    color: palette.text.secondary,
    fontFamily: 'Public Sans, sans-serif',
    fontWeight: 400,
    fontSize: '12px',
    letterSpacing: '0.33px',
    lineHeight: '18px'
  },
  overline: {
    color: palette.text.primary,
    fontSize: '12px',
    fontWeight: 700,
    letterSpacing: '0.33px',
    lineHeight: '18px',
    textTransform: 'uppercase'
  },
  tablecelltext: {
    color: palette.text.primary,
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '22px'
  }
};
